import { ConstructClassWithPrivateMembers } from '../../../misc/helpers/ClassWithPrivateMembers';
import { NOTIFICATION_PRIVATE } from './privates';
import { IsObject } from '../../../helpers';
export function ConstructNotification(instance, name, value) {
    ConstructClassWithPrivateMembers(instance, NOTIFICATION_PRIVATE);
    const privates = instance[NOTIFICATION_PRIVATE];
    privates.name = name;
    privates.value = value;
}
export function IsNotification(value) {
    return IsObject(value)
        && value.hasOwnProperty(NOTIFICATION_PRIVATE);
}
//# sourceMappingURL=constructor.js.map